<template>
  <div class="contentBox px-8 w-full">
    <div class="content flex items-center gap-6">
      <div class="flex-1 flex items-center justify-between gap-8">
        <!-- <svg-icon class="cursor-pointer" v-show="!menuCollapse" name="collapse" color="#515f8f" @click="handleSetMenuCollapse"></svg-icon> -->
        <!-- <svg-icon class="cursor-pointer" v-show="menuCollapse" name="expand" color="#515f8f" @click="handleSetMenuCollapse"></svg-icon> -->
        <img v-if="themeMode === 'dark'" src="@/assets/logo.png" alt="" width="100" class="h-fit mt-3">
        <img v-else src="@/assets/logo-light.png" alt="" width="100" class="h-fit mt-3">
        <!-- <menu-com /> -->
        <tag-com />
      </div>
      <div class="flex items-center gap-1 cursor-pointer" style="color: var(--el-menu-text-color);" @click="handleRefresh">
        <el-icon :title="t('刷新')"><Refresh /></el-icon>
        {{ t('刷新') }}
      </div>
      <el-switch
        v-model="themeMode"
        active-value="dark"
        inactive-value="light"
        @change="handleChangeMode"
        size="small"
      >
        <template #active-action>
          <el-icon><Moon /></el-icon>
        </template>
        <template #inactive-action>
          <el-icon color="#000"><Sunny /></el-icon>
        </template>
      </el-switch>
      <div class="lang cursor-pointer flex items-center" @click="handleChangeLang">
        <svg-icon class="app-color--gray dark:text-[#CFD3DC]" name="language" />
      </div>
      <el-dropdown @command="handleCommand">
        <div class="flex items-center dark:text-[#CFD3DC]">
          <el-avatar class="mr-2" :size="30" icon="UserFilled" />
          {{ userData ? userData.username : '' }}
        </div>
        <template #dropdown>
          <el-dropdown-menu>
            <el-dropdown-item command="settings">{{ t('个人中心') }}</el-dropdown-item>
            <el-dropdown-item command="logout">{{ t('退出') }}</el-dropdown-item>
          </el-dropdown-menu>
        </template>
      </el-dropdown>
    </div>
  </div>
</template>

<script setup>
import { useRouter } from 'vue-router'
import { ElMessageBox } from 'element-plus'
import { logout } from '@/api'
import { computed, ref, nextTick } from 'vue'
import avatar from '@/assets/avatar1.png'
import { useGlobalStore } from '@/store'
import { useTagsStore } from '@/store/tags'
import SvgIcon from '@/components/svgIcon/index.vue'
import MenuCom from '@/components/menu/index.vue'
import TagCom from '@/components/tag/index.vue'
import { Moon, Sunny } from '@element-plus/icons-vue'
import { useI18n } from 'vue-i18n'
const { t, locale } = useI18n()


const router = useRouter()
const store = useGlobalStore()
const tagsStore = useTagsStore()
const userData = computed(() => store.userData)
const menuCollapse = computed(() => store.menuCollapse)

const themeMode = ref(localStorage.theme)
const handleChangeMode = (flag, event) => {
  // 获取点击点坐标
  const x = event?.clientX ?? window.innerWidth
  const y = event?.clientY ?? 0
  const endRadius = Math.hypot(Math.max(x, innerWidth - x), Math.max(y, innerHeight - y))
  
  // 开启视图过渡
  const transition = document.startViewTransition(async () => {
    // ✅ 现在浏览器已经捕捉完旧视图，可以安全修改 DOM（不会提前闪）
    store.setTheme(flag)
    localStorage.theme = flag
    document.documentElement.classList.toggle('dark', flag === 'dark')
    await nextTick(); // 等 Vue DOM 更新
  })
  transition.ready.then(() => {
    // 💫 扩散动画
    const clipPath = [
      `circle(0px at ${x}px ${y}px)`,
      `circle(${endRadius}px at ${x}px ${y}px)`,
    ];

    document.documentElement.animate(
      {
        clipPath: flag === 'dark' ? [...clipPath].reverse() : clipPath,
      },
      {
        duration: 450,
        easing: "ease-in",
        pseudoElement: flag === 'dark'
          ? "::view-transition-old(root)"
          : "::view-transition-new(root)",
      }
    );
  })
}

const handleSetMenuCollapse = () => {
  store.setMenuCollapse(!menuCollapse.value)
}

const handleLogout = () => {
  ElMessageBox.confirm(t('确定退出吗？'), t('提示'), {
    type: 'warning'
  }).then(() => {
    logout({
      token: localStorage.getItem('token')
    }).then(() => {
      router.push('/login')
      localStorage.removeItem('token')
    })
  }).catch(() => {})
}

const handleCommand = (command) => {
  if (command === 'logout') {
    handleLogout()
  } else if (command === 'settings') {
    router.push('/user/account')
  }
}

const handleChangeLang = () => {
  locale.value = store.locale === 'zh' ? 'en' : 'zh'
  store.setLocale(locale.value)
  localStorage.setItem('lang', locale.value)
}
const handleRefresh = () => {
  tagsStore.deleteCachedTags(router.currentRoute.value)
  const { path, query } = router.currentRoute.value
  nextTick(() => {
    router.replace({
      path: '/redirect' + path,
      query
    })
  })
}
</script>

<style lang="scss" scoped>
.lang {
  .svg-icon {
    width: 1.5rem !important;
    height: 1.5rem !important;
  }
}
.contentBox {
  transform: translateZ(0);
  // box-shadow: 0 2px 8px var(--itsop-background);
  border-bottom: solid 1px var(--itsop-border);
  z-index: 250;
  position: absolute;
  top: 0;
}
.content {
  width: var(--itsop-content-width);
  margin: 0 auto;
  height: var(--itsop-header-height);
  line-height: var(--itsop-header-height);
  .logo {
    width: 200px;
  }
  a {
    color: var(--itsop-font-2);
  }
  .router-link-active {
    font-weight: bolder;
    color: var(--el-color-primary);
  }
}
</style>